/* global */

export default function($log, $sce, ProfileClass) {
  'ngInject';

  const { profile } = ProfileClass.profileComplete;

  const vm = this;
  vm.$onInit = activate;

  function activate() {
    $log.debug('JotForm component activated.');

    vm.jotFormUrl = $sce.trustAsResourceUrl(
      `https://form.jotform.com/${vm.jotFormId}?isIframeEmbed=1=&name[first]=${profile.first}&name[last]=${
        profile.last
      }&email=${profile.email}`
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/jotForm/controller.js